import type { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/vendors/settings/line_user_accounts/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/vendors/settings/line_user_accounts';

const LineUserAccounts: NextPage = () => (
  <>
    <NskHead title="LINEアカウント設定" />
    <Component />
  </>
);

export default LineUserAccounts;
